import { Injectable } from "@angular/core";
import { ApiService } from "@tylertech/core-module";
import
{
    IActionResult,
    IServiceOrder,
    IServiceOrderAlert,
    IServiceOrderAlertCriteria,
    IServiceOrderCharge,
    IServiceOrderChargeCriteria,
    IServiceOrderCost,
    IServiceOrderCostCriteria,
    IServiceOrderCriteria,
    IServiceOrderModuleControl,
    IServiceOrderServiceInfo,
    IServiceOrderVoidCriteria,
} from "../interfaces";
@Injectable()
export class ServiceOrderWizardApiService
{
    constructor(
        private readonly $apiService: ApiService
    ) { }

    AutoConnectLandlord(pCriteria: IServiceOrderCriteria): Promise<IServiceOrder>
    {
        return this.$apiService.sendAuth("IServiceOrderWizardService/AutoConnectLandlord", pCriteria);
    }

    CompleteServiceOrder(pServiceOrder: IServiceOrder): Promise<IActionResult>
    {
        return this.$apiService.sendAuth("IServiceOrderWizardService/CompleteServiceOrder", pServiceOrder);
    }

    DeleteServiceOrder(pServiceOrderId: string): Promise<IActionResult>
    {
        return this.$apiService.sendAuth("IServiceOrderWizardService/DeleteServiceOrder", pServiceOrderId);
    }

    GetServiceOrder(pServiceOrderId: string): Promise<IServiceOrder>
    {
        return this.$apiService.sendAuth("IServiceOrderWizardService/GetServiceOrder", pServiceOrderId);
    }

    GetServiceOrderModuleControl(): Promise<IServiceOrderModuleControl>
    {
        return this.$apiService.sendAuth("IServiceOrderWizardService/GetServiceOrderModuleControl");
    }

    GetTSMReads(pServiceOrder: IServiceOrder): Promise<number[]>
    {
        return this.$apiService.sendAuth("IServiceOrderWizardService/GetTSMReads", pServiceOrder);
    }

    GetUndoWarningMessage(pServiceOrderId: string): Promise<string>
    {
        return this.$apiService.sendAuth("IServiceOrderWizardService/GetUndoWarningMessage", pServiceOrderId);
    }

    NewServiceOrder(pCriteria: IServiceOrderCriteria): Promise<IServiceOrder>
    {
        return this.$apiService.sendAuth("IServiceOrderWizardService/NewServiceOrder", pCriteria);
    }

    NewServiceOrderAlert(pCriteria: IServiceOrderAlertCriteria): Promise<IServiceOrderAlert>
    {
        return this.$apiService.sendAuth("IServiceOrderWizardService/NewServiceOrderAlert", pCriteria);
    }

    NewServiceOrderCharge(pCriteria: IServiceOrderChargeCriteria): Promise<IServiceOrderCharge>
    {
        return this.$apiService.sendAuth("IServiceOrderWizardService/NewServiceOrderCharge", pCriteria);
    }

    NewServiceOrderCost(pCriteria: IServiceOrderCostCriteria): Promise<IServiceOrderCost>
    {
        return this.$apiService.sendAuth("IServiceOrderWizardService/NewServiceOrderCost", pCriteria);
    }

    ResetServiceOrderServices(pServiceOrder: IServiceOrder): Promise<IServiceOrderServiceInfo[]>
    {
        return this.$apiService.sendAuth("IServiceOrderWizardService/ResetServiceOrderServices", pServiceOrder);
    }

    SaveCostsForCompletedServiceOrder(pServiceOrderCosts: IServiceOrderCost[]): Promise<IServiceOrderCost[]>
    {
        return this.$apiService.sendAuth(
            "IServiceOrderWizardService/SaveCostsForCompletedServiceOrder",
            pServiceOrderCosts
        );
    }

    SaveServiceOrder(pServiceOrder: IServiceOrder): Promise<IActionResult>
    {
        return this.$apiService.sendAuth("IServiceOrderWizardService/SaveServiceOrder", pServiceOrder);
    }

    UndoServiceOrder(pServiceOrder: IServiceOrder): Promise<IActionResult>
    {
        return this.$apiService.sendAuth("IServiceOrderWizardService/UndoServiceOrder", pServiceOrder);
    }

    VoidServiceOrder(pCriteria: IServiceOrderVoidCriteria): Promise<IActionResult>
    {
        return this.$apiService.sendAuth("IServiceOrderWizardService/VoidServiceOrder", pCriteria);
    }
}
